import { useEffect, useState } from "react";
import { BiCheck, BiCross, BiLoaderAlt, BiTime, BiX } from "react-icons/bi";
import EventsService from "../services/EventsService";

const TicketsBuyingCheckingModal = ({ token, onDismiss }) => {
    const [loading, setLoading] = useState(null);
    const [orderInfos, setOrderInfos] = useState(null);

    const getTicketInfos = (_token) => {
        setLoading('order-infos');
        EventsService
            .getOrderInfos(_token)
            .then(response => {
                setOrderInfos(response);
            })
            .catch(err => setOrderInfos({ status: 'UNPAID' }))
            .finally(() => setLoading(null));
    };

    useEffect(() => {
        getTicketInfos(token);
    }, []);

    return (
        <div className="fixed z-10 top-0 left-0 h-screen w-screen bg-[rgba(0,0,0,0.4)] flex items-center justify-center">
            <div className="w-11/12 max-w-[400px] min-h-[350px] bg-white rounded-md p-10 flex justify-center items-center relative">
                {loading === 'order-infos' ? (
                    <BiLoaderAlt className={`animate-spin text-5xl text-neutral-400`} />
                ) : (
                    <>
                    <button
                        className="w-6 h-6 rounded-full bg-gray-300 text-gray-600 text-base absolute right-5 top-5"
                        onClick={() => onDismiss && onDismiss()}
                    >&times;</button>
                    <div className="text-center">
                        {orderInfos?.status !== 'PAID' ? (
                            <>
                                <div className="w-fit m-auto">
                                    <BiX className="text-9xl text-red-500" />
                                </div>
                                <h4 className="text-lg text-gray-600 font-bold mt-0">Paiement non reçu</h4>
                                <p className="text-base text-gray-500">
                                    Si vous avez éffectué un paiement, nous ne l'avons pas encore reçu.
                                    Patientez quelques instants puis actualisez cette page. Et si le problème persiste,
                                    &nbsp;<a className="text-orange-500" href="https://wa.me/2250759367623" target="_blank">Contactez le support</a>
                                </p>
                            </>
                        ) : (
                            <>
                                <div className="w-fit m-auto">
                                    <BiCheck className="text-9xl text-green-500" />
                                </div>
                                <h4 className="text-lg text-gray-600 font-bold mt-0">Paiement éffectué</h4>
                                <p className="text-base text-gray-500 mt-1">
                                    Votre paiement a bien été reçu. <b>Vos billets on été envoyés à l'adresse email que vous avez
                                    renseigné lors de votre paiement</b>.
                                    <br/><br/>
                                    Si vous ne recevez rien au bout de 15 minutes, veuillez <a className="text-orange-500" href="https://wa.me/2250759367623" target="_blank">Contactez le support</a>.
                                </p>
                            </>
                        )}
                    </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default TicketsBuyingCheckingModal;